// extracted by mini-css-extract-plugin
export default {"badge":"IconBadgeControl-module__badge__E2F9m","badge__text":"IconBadgeControl-module__badge__text__dyXGm"};